import { ReactNode, useState } from "react";

import { Typography } from "antd";

export function TextWithShowMore({ children }: { children: ReactNode }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <Typography.Paragraph
      ellipsis={{
        rows: 2,
        expandable: "collapsible",
        expanded,
        onExpand: (_, info) => setExpanded(info.expanded),
      }}
      style={{
        fontSize: "inherit",
        fontFamily: "inherit",
        fontWeight: "inherit",
        lineHeight: "inherit",
        color: "inherit",
        margin: 0,
      }}
    >
      {children}
    </Typography.Paragraph>
  );
}
